/**
 * Composable para manejar la lógica reactiva del breadcrumb
 */
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { buildBreadcrumb } from '@/helpers/breadcrumbHelper';

/**
 * Composable que proporciona la configuración del breadcrumb basada en la ruta actual
 * @returns {object} - Objeto con breadcrumb reactivo
 */
export function useBreadcrumb() {
   const route = useRoute();
   const router = useRouter();
   const store = useStore();

   const breadcrumb = computed(() => {
      // Forzar recálculo cuando cambia route.name o route.path
      const routeName = route.name;
      const routePath = route.path;

      // Si no hay nombre de ruta, retornar breadcrumb vacío
      if (!routeName) {
         return {
            home: {
               icon: 'pi pi-home',
               route: { name: 'menu' },
            },
            items: [],
         };
      }

      // Construir breadcrumb basado en la ruta actual y sus metadatos
      // Pasar router para verificación dinámica de rutas
      return buildBreadcrumb(routeName, route.meta || {}, store, router);
   });

   return {
      breadcrumb,
   };
}
